angular.module('note')
    .controller('NoteDialogController', function ($timeout, $scope, $rootScope, $filter, $uibModalInstance, data, toastr, Note) {
        this.$onInit = () => {
            this.item = data;
        };

        this.cancel = () => $uibModalInstance.dismiss('Canceled');

        this.save = () => {
            let promise
            if (this.item.id !== null) {
                promise = Note.update(this.item).$promise
            } else {
                promise = Note.save(this.item).$promise
            }
            return promise.then(result => {
                $rootScope.$broadcast("note.updated")
                $uibModalInstance.close(result)
                toastr.success("Zapisano")
            })
        };

        this.onPrivateChanged = () => {
            if (this.item.private === true) {
                this.item.subscribers = [];
                this.item.subscriberGroups = [];
            }
        }
    })
